import Styles from "./CallLog.module.scss";


const CallLog = () => {
    return (
        <div className={Styles.screen}>
            <div className={Styles.container}>
                <div className={Styles.label}>
                    No recent calls or messages
                </div>
                <div className={Styles.sub_label}>
                    A record of your calls and messages will appear here
                </div>
            </div>
        </div>
    )
}

export default CallLog
